const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getAuditLogs(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.userId) params.append('userId', filters.userId);
  if (filters.action) params.append('action', filters.action);
  if (filters.resourceType) params.append('resourceType', filters.resourceType);
  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (filters.limit) params.append('limit', filters.limit.toString());
  if (filters.offset) params.append('offset', filters.offset.toString());
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/audit-log${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch audit logs');
  }
  
  return response.json();
}

export async function getAuditLogEntry(orgId, logId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/audit-log/${logId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }
    throw new Error('Failed to fetch audit log entry');
  }
  
  const data = await response.json();
  return data.entry;
}
